function index() {
  return (
    <form className="w-full max-w-md">
      <div className="relative">
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
          <svg
            className="text-semiGery size-5"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 20 20"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
            />
          </svg>
        </div>
        <input
          type="search"
          id="default-search"
          className="bg-gery block h-11 w-[22.5rem] rounded-lg pr-11 text-sm leading-5 text-gray-900 transition-all duration-300 ease-in-out"
          placeholder="جستجو کنید..."
          required
        />
      </div>
    </form>
  );
}

export default index;
